import type { ComponentType } from 'react'
import type { ModoVisualizacao } from '../../visualizacao3d/componentes/contextoMaquete'
import {
  IconeModuloCinematica,
  IconeModuloCorte,
  IconeModuloEstabilizacao,
  IconeModuloEstrutura,
  IconeModuloExtracao,
  IconeModuloTabletop,
  type PropsIcone,
} from '../icones'

/**
 * Os seis módulos do laboratório, numa tabela só.
 *
 * Antes isso vivia em `App.tsx` como três `Record` paralelos (`ABAS`, `TITULOS`,
 * `ICONES_NAV`) que precisavam ser mantidos em sincronia na mão. Acrescentar um
 * módulo agora é acrescentar uma linha.
 */

export type IdModulo =
  | 'maquete'
  | 'cinematica'
  | 'estabilizacao'
  | 'corte'
  | 'tabletop'
  | 'extracao'

export interface Modulo {
  id: IdModulo
  /** Nome curto, usado na navegação. */
  rotulo: string
  /** Nome completo, usado em títulos e rótulos acessíveis. */
  titulo: string
  /** Preset de visualização 3D que o módulo assume ao ser aberto. */
  modo: ModoVisualizacao
  Icone: ComponentType<PropsIcone>
}

export const MODULOS: readonly Modulo[] = [
  {
    id: 'maquete',
    rotulo: 'Estrutura veicular',
    titulo: 'Estrutura veicular',
    modo: 'estrutura',
    Icone: IconeModuloEstrutura,
  },
  {
    id: 'cinematica',
    rotulo: 'Cinemática',
    titulo: 'Cinemática',
    modo: 'cinematica',
    Icone: IconeModuloCinematica,
  },
  {
    id: 'estabilizacao',
    rotulo: 'Estabilização',
    titulo: 'Estabilização veicular',
    modo: 'estabilizacao',
    Icone: IconeModuloEstabilizacao,
  },
  {
    id: 'corte',
    rotulo: 'Oficina de corte',
    titulo: 'Oficina de corte e criação de espaço',
    modo: 'estrutura',
    Icone: IconeModuloCorte,
  },
  {
    id: 'tabletop',
    rotulo: 'Table top',
    titulo: 'Table top de ocorrência',
    modo: 'tabletop',
    Icone: IconeModuloTabletop,
  },
  {
    id: 'extracao',
    rotulo: 'Extração de vítima',
    titulo: 'Extração de vítima',
    modo: 'extracao',
    Icone: IconeModuloExtracao,
  },
]

export function moduloPorId(id: IdModulo): Modulo {
  const achado = MODULOS.find((modulo) => modulo.id === id)
  if (!achado) throw new Error(`Módulo desconhecido: ${id}`)
  return achado
}
